import { isLocalhostDevMode } from "@/utils/utils";
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import type { AgentBrandingEnumeration } from "../enumerations/types";

interface BrandingState {
  branding?: AgentBrandingEnumeration;
  actions: {
    setBranding: (branding?: AgentBrandingEnumeration) => void;
  };
}

/**
 * The last branding the server sent, kept out of the query cache: the login screen needs it on the first render
 * and after a logout, a cache wipe or the persister's 24-hour maxAge.
 */
const useBrandingStore = create<BrandingState>()(
  devtools(
    persist(
      (set) => ({
        branding: undefined,
        actions: {
          // Keep the stored branding if a response comes without one.
          setBranding: (branding) => set((state) => ({ branding: branding ?? state.branding })),
        },
      }),
      {
        name: "cliip:branding",
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({ branding: state.branding }),
      },
    ),
    { name: "branding", enabled: isLocalhostDevMode() },
  ),
);

export const useBranding = () => useBrandingStore((state) => state.branding);

export const brandingActions = () => useBrandingStore.getState().actions;
